module.exports = __webpack_public_path__ + "1ca3840f9b2c7f5a9d2ad3a8c150e200.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-twitter-grey.svg
// module id = QTOC
// module chunks = 5